<template>
    <div>
        <div class="setting-left" :style="`height:${columnH}px`">
            <ul>
                <li>
                    <router-link to="/main/primary/accounting/dataAccounting">学生统计</router-link>
                </li>
                <li>
                    <router-link to="/main/primary/accounting/signupAccounting">报名统计</router-link>
                </li>
                <li>
                    <router-link to="/main/primary/accounting/reviewAccounting">审核统计</router-link>
                </li>
            </ul>
        </div>
        <div class="setting-right" :style="`height:${columnH}px`">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
    import mixins from '@/mixins/windowResize';

    export default {
        name: "AccountingLayout",
        mixins:[mixins],
    }
</script>

<style lang="scss" scoped>
    @import "../../../styles/mixin";

    @include globalstyle;

    .setting-left {
        float: left;
        width: 12%;
        border-right: 1px solid #e6e6e6;
        .router-link-active {
            color: #20a0ff;
        }
        ul {
            margin: 0;
            li {
                a {
                    text-decoration: none;
                    display: block;
                    height: 56px;
                    line-height: 56px;
                    font-size: 14px;
                    color: #48576a;
                    padding: 0 20px;
                    cursor: pointer;
                    position: relative;
                    transition: border-color .3s,background-color .3s,color .3s;
                    box-sizing: border-box;
                    white-space: nowrap;
                    &:hover {
                        background-color: #d1dbe5;
                    }
                }
            }
        }

    }
    .setting-right {
        float: right;
        width: 86%;
        overflow-y: auto;
    }

</style>



// WEBPACK FOOTER //
// src/views/primary/accounting/AccountingLayout.vue